import React from "react";
import { AiOutlineMail } from "react-icons/ai";
import { CiLocationOn } from "react-icons/ci";
//import {FaRegCalendarAlt} from "react-icons/fa"
import { FiLinkedin } from "react-icons/fi";
import MessageForm from "./MessageForm";

function Contact({ mode }) {
  return (
    <div
      className="  font-Poppins md:h-[1000px] h-[1380px] md:pt-[6px]   "
      id="ContactMe"
    >
      <div className="mt-[100px]">
        <div className=" flex flex-col justify-center items-center ">
          <div className=" text-[3rem]">Contact Me</div>
          <div className="opacity-75">
            Want to connect? My inbox is always open!
          </div>
        </div>
      </div>

      <div className="flex flex-col  md:flex-row  md:pt-[0px]  pt-[240px] px-12   md:justify-center none  md:items-center   md:mx-auto  md:space-x-32  mt-4  ">
        <div className="-mt-[210px]">
          <div className="flex flex-col   space-y-14 ">
            <a href="mailto: tanmay26981@gmail.com" target={"_blank"}>
              <div className="flex flex-row space-x-3 ">
                <AiOutlineMail className="text-deep mt-2 " size={30} />
                <div className="flex flex-col">
                  <p className="font-bold"> Email</p>
                  <p className="text-[#e4dede]">tanmay031170@gmail.com</p>
                </div>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/in/tanmay-kumar-438403222/"
              target={"_blank"}
            >
              <div className="flex flex-row space-x-3 ">
                <FiLinkedin className="text-deep mt-2 " size={30} />
                <div className="flex flex-col">
                  <p className="font-bold">Linkedin</p>
                  <p className="text-[#e4dede]">tanmay-kumar-438403222</p>
                </div>
              </div>
            </a>

            <a
              href="https://www.google.com/maps/place/Kolkata,+West+Bengal/@22.5150888,88.3919528,15.56z/data=!4m6!3m5!1s0x39f882db4908f667:0x43e330e68f6c2cbc!8m2!3d22.572646!4d88.363895!16zL20vMGN2dzk?entry=ttu"
              target={"_blank"}
            >
              <div className="flex flex-row space-x-3 ">
                <CiLocationOn className="text-deep mt-2 font-bold " size={30} />
                <div className="flex flex-col">
                  <p className="font-bold"> Location</p>
                  <p className="text-[#e4dede]">Kolkata,India</p>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div>
          <MessageForm mode={mode} />
        </div>
      </div>
    </div>
  );
}

export default Contact;
